<template>
  <b-container>
    <b-row>
      <b-col cols="4"
        ><b-form-select
          size="sm"
          v-model="roadType"
          :options="optionsRT"
        ></b-form-select
      ></b-col>
      <b-col cols="4"
        ><b-form-input
          v-model="keyword"
          placeholder="Search..."
          @keyup.enter="Search"
          size="sm"
        ></b-form-input>
      </b-col>
      <b-col cols="2">
        <b-button @click="Search" size="sm">Search</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "SearchBar",
  data: function() {
    return {
      roadType: null,
      keyword: "",
      optionsRT: [
        { value: null, text: "- Select Road Type -" },
        { value: "Interstate", text: "Interstate" },
        { value: "NC Routes", text: "NC Routes" },
        { value: "SR Routes", text: "SR Routes" },
        { value: "US Routes", text: "US Routes" },
      ],
    };
  },
  methods: {
    Search: function() {
      var searchObj = {
        keyword: this.keyword,
        roadType: this.roadType,
      };
      this.$emit("SearchKeyRT", searchObj);
    },
  },
};
</script>

<style scoped>
.custom-select {
  width: 90% !important;
}

.form-control {
  width: 90% !important;
}</style
>>
